<template>
  <div class="modal fade" tabindex="-1" :id="id">
    <div class="modal-dialog modal-lg">
      <form id="kt_modal_form_other" @submit.prevent="addCategory" class="form mt-5" >
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('post_category.add') }}</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
                  <span class="svg-icon svg-icon-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                            fill="currentColor"/>
                      <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                            fill="currentColor"/>
                    </svg>
                  </span>
            </div>
          </div>

          <div class="modal-body">
            <RequiredText />

              <div class="row">
                <Input
                    containerClass="col-12 mb-2"
                    name="title"
                    :label="$t('label.title')"
                    :placeholder="$t('label.title')"
                    v-model="formData.title"
                />
              </div>
          </div>
          <div class="modal-footer">
            <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click="closeModal"></Button>
            <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="isLoading"></Button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>

import {ref, watch} from 'vue';
import { useStore } from "vuex";
import Button from "@/components/Button.vue";
import Input from "@/components/Input.vue";
import RequiredText from "@/components/RequiredText.vue";


const emits = defineEmits(['load', 'addType'])
const store = useStore()


const formData = ref({
  id: '',
  title: '',
})

const isLoading = ref(false)


function closeModal(){
  $('#categoryCreateModal').modal('toggle');
}

async function addCategory() {
  isLoading.value = true

    await store.dispatch('user/CreatePostCategories', formData.value)

        .then((response) => {
          emits('addType', response.data?.data?.id)
          emits('load')
          isLoading.value = false
          closeModal()
          formData.value.title = ''
          window.toastr.success(i18n.global.t("post_category.post_created"))
        })
        .catch(err => {
          isLoading.value = false
        })
}

</script>
